import { TFunction } from 'i18next';
import {
  DEFAULT_BIG_IMAGE_TRANSFORMATIONS,
  DEFAULT_IMAGE_TRANSFORMATIONS,
  PictureDesktopNames,
  PictureTransformations,
} from 'common/components';
import { WINDOWS_LANDING_NAME } from '../../windows-constants';

export const IMAGE_PER_PAGE = 5;

export type WindowsProjectGalleryStructure = {
  alt: string;
  name: string;
  src: string;
  srcSmall: string;
  transformations?: PictureTransformations;
};

const WINDOWS_PROJECT_NAME_LIST = [
  '12.06.2022',
  '22.10.2022',
  '03.09.2022',
  '22.10.2022',
  '05.11.2022',
  '22.10.2022',
  '23.01.2022',
  '05.11.2022',
  '03.09.2022',
  '12.06.2022',
  '16.06.2022',
  '16.06.2022',
  '22.10.2022',
  '12.06.2022',
  '05.11.2022',
];

const PROJECT_GALLERY_IMAGE_TRANSFORMATION = {
  ...DEFAULT_IMAGE_TRANSFORMATIONS,
  [PictureDesktopNames.ImgTablet]: {
    ...DEFAULT_IMAGE_TRANSFORMATIONS.imgTablet,
    height: 380,
    width: 660,
  },
};

const PROJECT_GALLERY_BIG_IMAGE_TRANSFORMATION = {
  ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS,
  [PictureDesktopNames.ImgTablet]: {
    ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS.imgTablet,
    height: 784,
    width: 660,
  },
};

export const getWindowsProjectGalleryList = (t: TFunction): WindowsProjectGalleryStructure[] => WINDOWS_PROJECT_NAME_LIST.map(
  (name: string, index: number) => {
    const imageName = index + 1;

    const baseInfo = {
      alt: t('project-gallery-section.item-title', { date: name }),
      name: `${imageName}.jpg`,
      src: `${WINDOWS_LANDING_NAME}/projects-popup/${imageName}.jpg/${imageName}.jpg`,
      srcSmall: `${WINDOWS_LANDING_NAME}/projects/${imageName}.jpg/${imageName}.jpg`,
      transformations: PROJECT_GALLERY_IMAGE_TRANSFORMATION,
    };

    if (index % 10 === 4 || index % 10 === 7) {
      return {
        ...baseInfo,
        transformations: PROJECT_GALLERY_BIG_IMAGE_TRANSFORMATION,
      };
    }

    return baseInfo;
  }
);
